import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src537944096/src/scriptunlock-production/node_modules/next/dist/client/app-dir/link.js");
